import {isFeatureEnabled} from '@github-ui/feature-flags'

export const SANDBOX_COMPUTE_PROVIDER = 'sandboxes'
export const SANDBOX_REMOTE_BYPASS_FLAG = 'copilot_mission_control_sandbox_remote_bypass'

export function isSandboxComputeProvider(provider: string | undefined): boolean {
  return provider === SANDBOX_COMPUTE_PROVIDER
}

export function isSandboxRemoteBypassEnabled(provider: string | undefined): boolean {
  return isSandboxComputeProvider(provider) && isFeatureEnabled(SANDBOX_REMOTE_BYPASS_FLAG)
}

export function effectiveRemoteControlPolicyEnabled(
  remoteControlPolicyEnabled: boolean | undefined,
  computeProvider: string | undefined,
): boolean | undefined {
  if (isSandboxRemoteBypassEnabled(computeProvider)) {
    return true
  }
  return remoteControlPolicyEnabled
}
